import { initiateRecognitionAttachmentUpload } from '@kudos/http-client'
import AttachmentsField from '@shared/forms/AttachmentsField'
import RichTextEditorField from '@shared/forms/richTextEditorField/RichTextEditorField'
import { MAX_MESSAGE_CHARS } from '@shared/wallPost/constants'
import { T, useT } from '@transifex/react'
import { Control, FieldValues, Path } from 'react-hook-form'

type MessageAndAttachmentsSectionProps<T extends FieldValues> = {
  control: Control<T>
  canRefineMessage: boolean
  canUpgradeLicense: boolean
  includeAttachments?: boolean
  includeGif?: boolean
  autoFocus?: boolean
}

const MessageAndAttachmentsSection = <T extends FieldValues>({
  control,
  canRefineMessage,
  canUpgradeLicense,
  includeAttachments = true,
  includeGif = true,
  autoFocus = false,
}: MessageAndAttachmentsSectionProps<T>) => {
  const t = useT()

  return (
    <>
      <RichTextEditorField
        name={'message' as Path<T>}
        control={control as unknown as Control<FieldValues>}
        placeholder={t(
          "Make it meaningful! Describe their contributions and the positive impact they've had on you or the organization. Type @ to tag someone.",
        )}
        charCounterMax={MAX_MESSAGE_CHARS}
        label={<T _str="Message" />}
        areMentionsSupported
        areGifsSupported={includeGif}
        imageUploadFn={includeAttachments ? initiateRecognitionAttachmentUpload : undefined}
        attachmentUploadFn={includeAttachments ? initiateRecognitionAttachmentUpload : undefined}
        isFullVersion={false}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        canRefineMessage={canRefineMessage || canUpgradeLicense}
      />
      {includeAttachments && (
        <AttachmentsField
          hideUploadButton={true}
          name="attachments"
          control={control as unknown as Control<FieldValues>}
          mutationFn={initiateRecognitionAttachmentUpload}
        />
      )}
    </>
  )
}

export default MessageAndAttachmentsSection
